import React from 'react';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import Page from '../../../components/Page/Page';
import SignupGrid from '../../../components/Home/SignupGrid/SignupGrid';
import getAllHomePageSettings from './getAllHomePageSettings.graphql';
import { HomeProvider } from '../../context/homeContext';
import FooterImageSection from '../../../components/Home/FooterImageSection/FooterImageSection';
import s from './Driver.css';

class Driver extends React.Component {

  render() {
    const { getAllHomePageSettings: { loading, getAllHomePageSettings }, data } = this.props
    let homeSettings = {}
    if (!loading) {
      getAllHomePageSettings && getAllHomePageSettings?.homePageData?.map((item) => {
        homeSettings[item.name] = item.value
      })
    }

    return (
      <div>
        {!loading &&
          <div>
            <HomeProvider value={homeSettings}>
              <div className={s.homeBanner} />
              <Page
                html={data?.content}
                title={data?.metaTitle}
                pageBanner={data?.pageBanner}
              />
              <SignupGrid className={s.noMargin}/>
              <FooterImageSection />
            </HomeProvider>
          </div>}
      </div>
    );
  }
}

export default compose(
  withStyles(s),
  graphql(getAllHomePageSettings, {
    name: 'getAllHomePageSettings',
    options: {
      ssr: true
    }
  })
)(Driver);
